import { forwardRef } from 'preact/compat';
import { useFormStore } from '@/features/form';

export default forwardRef(function HandleTabIndex(
	{ children, component = 'div', useTabIndexWhenOpen, ...props },
	ref
) {
	const { formType, formOpen } = useFormStore();
	//tabindex - 1 when form is closed (avoids 'ghost tabbing in slide-in form)
	const tabIndex = formOpen || formType === 'embed' ? 0 : -1;
	const Component = component;

	return (
		<Component
			ref={ref}
			{...(useTabIndexWhenOpen || tabIndex === -1 ? { tabIndex: tabIndex } : {})}
			{...props}
		>
			{children}
		</Component>
	);
});
